<template>
  <v-card>
    <v-tabs
      v-model="tab"
      background-color="accent"
      light
      fixed-tabs
      icons-and-text
      height="80"
      next-icon="mdi-arrow-right-bold-box-outline"
      prev-icon="mdi-arrow-left-bold-box-outline"
      show-arrows
    >
      <v-tab
        v-for="item in items"
        :key="item.tab"
      >
        {{ item.tab }}
        <v-icon>{{ item.icon }}</v-icon>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="item in items"
        :key="item.tab"
      >
        <v-card flat>
           <component v-bind:is="item.content"></component>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import competencesComponent from './competencesComponent'
import hardsoftwareResComponent from './hardsoftwareResComponent'

export default {
  components: {
    competencesComponent,
    hardsoftwareResComponent
  },

  data () {
    return {
      tab: null,
      items: [
        { tab: 'ML  Competences', content: 'competencesComponent', icon: 'mdi-account-group' },
        { tab: 'ML  Hard- & Software Ressources', content: 'hardsoftwareResComponent', icon: 'mdi-desktop-classic' }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mainComponent.vue